import React from 'react';
import { Box, Button } from '@mui/material';
import { TransformWrapper, TransformComponent } from 'react-zoom-pan-pinch';
import { isMobileOnly } from 'react-device-detect';
import { withTranslation, WithTranslation } from 'react-i18next';

import { ZoomInIcon, ZoomOutIcon } from '@icons';
import InfoBox from '../InfoBox';
import { useStyles } from './styles';

const DEFAULT_SCALE = 1;

interface IMapContentItem extends WithTranslation {
  url: string;
}

const MapContentItem = ({ url, t: translate }: IMapContentItem) => {
  const classes = useStyles();

  if (isMobileOnly) {
    return (
      <Box style={{ width: '400px', height: '270px' }}>
        <TransformWrapper
          initialScale={DEFAULT_SCALE}
          minScale={DEFAULT_SCALE}
          maxScale={5}
          limitToBounds={true}
          centerOnInit={true}
        >
          {({ zoomIn, zoomOut }) => (
            <>
              <Box sx={classes.transformActions}>
                <Button sx={classes.button(false)} onClick={() => zoomIn()}>
                  <ZoomInIcon />
                  <span>{translate('mapModal.zoomIn')}</span>
                </Button>
                <Button sx={classes.button(false)} onClick={() => zoomOut()}>
                  <ZoomOutIcon />
                  <span>{translate('mapModal.zoomOut')}</span>
                </Button>
                <InfoBox>{translate('mapModal.dragMove')}</InfoBox>
              </Box>

              <TransformComponent
                wrapperStyle={{ width: '100%', height: '100%' }}
              >
                <img
                  src={url}
                  alt="zoomable"
                  style={{ cursor: 'grab' }}
                  draggable={true}
                />
              </TransformComponent>
            </>
          )}
        </TransformWrapper>
      </Box>
    );
  }

  return <img src={url} />;
};

export default withTranslation()(MapContentItem);
